import React, { useEffect, useState, useRef, MutableRefObject } from 'react';
import { Box, Button, Container, Grid, Stepper, Step, StepLabel, Paper, CircularProgress } from '@mui/material';
import { PurchaseStepConnector, PurchaseStepIcon } from '../../shared/Stepper/PurchaseStepper';
import { CreatePurchase } from './Create/Create';
import { CollaboratorsPurchase } from './Collaborators/Collaborators';
import { ValuesPurchase } from './Values/Values';
import { SummaryPurchase } from './Summary/Summary';
import { PaymentPurchase } from './Payment/Payment';
import { FinishPurchase } from './Finish/Finish';
import { useAppDispatch, useAppSelector } from 'src/app/react/hooks/redux';
import { ConfirmationPurchase } from './Confirmation/Confirmation';
import { resetPurchase } from 'src/app/react/redux/purchase/actions';


const steps = [
    'Criar Recarga',
    'Favorecidos',
    'Crédito',
    'Confirmação',
    'Pagamento',
    'Concluído'
];

export const NewPurchase = () => {

    const dispatch = useAppDispatch();

    const { purchase, error, errorUpdate, errorUpdateMessage, loading, paymentLoading } = useAppSelector(state => state.purchase);
    const [ purchaseStep, setPurchaseStep ] = useState<number>(0);
    const handleCreatePurchase = useRef(null);
    const collaboratorsPurchaseRef = useRef(null);
    const valuesPurchaseRef = useRef(null);
    const [ purchaseType, setPurchaseType ] = useState<number>(0);
    const [ purchaseOption, setPurchaseOption ] = useState<number>(1);
    const [ selectedProducts, setSelectedProducts ] = useState<number[]>([]);
    const [ collaboratorHasError, setCollaboratorHasError ] = useState<boolean>();

    useEffect(()=> {
        dispatch(resetPurchase())
    },[])

    useEffect(() => {
    },[purchaseOption, collaboratorHasError]);

    const handleNextStep = () => {
        switch(purchaseStep){
            case 0:
                handleCreatePurchase.current();
                break;
            case 1:
                collaboratorsPurchaseRef?.current?.handleCollaboratorsPurchase();

                if(!collaboratorsPurchaseRef?.current?.handleCollaboratorsPurchase())
                    setPurchaseStep(purchaseStep+1)
                break;
            case 2:
                valuesPurchaseRef?.current?.handleValuesPurchase();
                if(!loading && !errorUpdate){
                    setPurchaseStep(purchaseStep+1)
                }
                break;
            case 3:
                    setPurchaseStep(purchaseStep+1)
                break;
            case 4:
                setPurchaseStep(purchaseStep+1)
                break;
            case 5:
                break;
            default:
                break;

        }
    }

    const handlePreviousStep = () => {
        switch(purchaseStep){
            case 1:
                collaboratorsPurchaseRef?.current?.handleCollaboratorsPurchase();
                setPurchaseStep(purchaseStep-1)
                dispatch(resetPurchase())
                break;
            case 2:
                if(purchaseOption == 3 || purchaseOption == 4){
                    valuesPurchaseRef?.current?.handleValuesPurchase();
                    setPurchaseStep(purchaseStep-1)
                }
                if(purchaseOption == 1 || purchaseOption == 2){
                    setPurchaseStep(purchaseStep-2)
                    dispatch(resetPurchase())
                }
                break;
            case 3:
                setPurchaseStep(purchaseStep-1)
                break;
            case 4:
                setPurchaseStep(purchaseStep-1)
                break;
            case 5:
                setPurchaseStep(purchaseStep-1)
                break;
            default:
                break;

        }
    }

    const handlePurchaseCreate = (purchaseType: number, purchaseOption: number, productsId: number[]) => {
        setPurchaseType(purchaseType);
        setPurchaseOption(purchaseOption);
        setSelectedProducts(productsId);

        if(purchaseOption == 3 || purchaseOption == 4){
            setPurchaseStep(purchaseStep+1)}
        if(purchaseOption == 1 || purchaseOption == 2){
            setPurchaseStep(purchaseStep+2)}
    }

    const handleHasError = (value: boolean) => { setCollaboratorHasError(value); }

    return (
        <>
            <Container maxWidth={false}>
                <Grid container alignItems="center" sx={{padding: '10px'}}>
                    <Grid item xs={12}>
                        <Box component='img' className="p-2" src="./assets/icons/arrow.svg"></Box>
                        <Box component='span' sx={{marginRight: '1rem'}} className="label-title">Nova Recarga</Box>
                    </Grid>
                    <Grid item xs={12} className="mt-3">
                        <Stepper alternativeLabel activeStep={purchaseStep} connector={<PurchaseStepConnector />}>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={PurchaseStepIcon}>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Grid>
                </Grid>
                <Container maxWidth={false} >
                    {loading &&
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Box className="component-box mt-2" sx={{minHeight: 300, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <CircularProgress />
                                </Box>
                            </Grid>
                        </Grid>
                    }
                    {!loading &&
                        <Grid>
                            <Box className="component-box mt-2">
                                { purchaseStep === 0 && <CreatePurchase onCreatePurchase={handleCreatePurchase} onPurchaseCreate={handlePurchaseCreate} key="createPurchase" /> }
                                { purchaseStep === 1 && <CollaboratorsPurchase ref={collaboratorsPurchaseRef} purchaseType={purchaseType} purchaseOption={purchaseOption} productsId={selectedProducts} key="collaboratorsPurchase"/> }
                                { purchaseStep === 2 && <ValuesPurchase ref={valuesPurchaseRef} purchaseType={purchaseType} purchaseOption={purchaseOption} productsId={selectedProducts} key="valuesPurchase" /> }
                                { purchaseStep === 3 && <ConfirmationPurchase key="confirmationPurchase" onPurchaseConfimation={handleNextStep}/> }
                                { purchaseStep === 4 && <PaymentPurchase key="paymentPurchase" onPaymentConfimation={handleNextStep} /> }
                                { purchaseStep === 5 && <FinishPurchase key="finishPurchase" onPaymentFail={handlePreviousStep} /> }
                            </Box>
                            <Grid container spacing={1}>
                                { (purchaseStep > 0 && purchaseStep < 5) &&
                                    <Grid item>
                                        <Box>
                                            <Button variant="outlined" onClick={handlePreviousStep}>Voltar</Button>
                                        </Box>
                                    </Grid>
                                }
                                { purchaseStep < 3 &&
                                    <Grid item>
                                        <Box>
                                            <Button variant="contained" disabled={loading} onClick={() => handleNextStep()}>Próximo</Button>
                                        </Box>
                                    </Grid>
                                }
                                { purchaseStep === 5 &&
                                    <Grid item>
                                        <Box>
                                            <Button variant="contained" onClick={() => setPurchaseStep(0)}>Nova Recarga</Button>
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    }
                </Container>
            </Container>
        </>
    );
}
